import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { changeTab, toTitleCase } from '../../../utils';
import PageContainer from '../../../components/Redesing/page-container';
import PageContent from '../../../components/Redesing/page-content';
import { Stack } from '@mui/material';
import { Card as MuiCard } from '@mui/material';
import OrganizationMaintenanceTicket from './maintenance-ticket';
import OrganizationMaintenanceLog from './maintenance-logs';
import OrganizationMaintenanceTag from './maintenance-tags';

function OrganizationMaintenanceIndex() {
  const { currentTab = 'tickets' } = useParams<{ currentTab: string }>();
  const [currentTabV, setCurrentTabV] = useState(currentTab);

  const handleTabsChange = useCallback(
    (event: React.SyntheticEvent, value: React.SetStateAction<string>) => {
      changeTab(value, currentTab, 'maintenance');
    },
    [currentTab]
  );

  useEffect(() => {
    if (currentTab !== currentTabV) {
      setCurrentTabV(currentTab);
    }
  }, [currentTab, currentTabV]);

  const activeTab = {
    tickets: <OrganizationMaintenanceTicket />,
    logs: <OrganizationMaintenanceLog />,
    tags: <OrganizationMaintenanceTag />,
  };

  return (
    <PageContainer spaceName={`Maintenance ${toTitleCase(currentTab)}`}>
      <PageContent
        detailedView={false}
        tabsList={[
          { label: 'Tickets', value: 'tickets' },
          { label: 'Logs', value: 'logs' },
          { label: 'Tags', value: 'tags' },
        ]}
        tabsChildren={
          <Stack paddingTop={1}>
            <MuiCard>{activeTab[currentTabV as 'tickets' | 'logs' | 'tags']}</MuiCard>
          </Stack>
        }
        currentTabV={currentTabV}
        handleTabsChange={handleTabsChange}
      />
    </PageContainer>
  );
}

export default OrganizationMaintenanceIndex;
